export enum YouTubeState {
  Unstarted = -1,
  Ended,
  Playing,
  Paused,
  Buffering,
  Unknown,
  VideoCued,
  Error,
};